<template>
  <div>
    <List
      url="users/"
      :title="title"
      titleClass="title"
      :data="searchData"
      :tanle="tanle"
      :operat="operat"
      :update="updateList"
      :afterList="dealList"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: flex;line-height:35px;">
        <label>用户名/姓名：</label>
        <el-input
          v-model="searchData.search"
          style="width:200px;margin-right:50px"
        ></el-input>
        <el-button @click="updateList++" type="primary" size="small"
          >搜索</el-button
        >
      </div>
      <template slot="Fresh">
        <el-button
          @click="add"
          type="primary"
          style="margin-bottom:10px;float:right"
          >新增</el-button
        >
      </template>
    </List>
    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/UserControl/UpdateBox.vue";
export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "username", label: "用户名" },
        { name: "name", label: "姓名" },
        { name: "email", label: "邮箱" },
        { name: "mobile", label: "手机号" },
        { name: "departmentName", label: "部门" },
        { name: "roleName", label: "角色" }
      ],
      title: "用户管理",
      searchData: {
        search: ""
      },
      operat: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      is_admin: false,
      updateType: "edit",
      updateList: 0,
      updateBlock: false,
      updateForm: {}
    };
  },
  mounted() {
    this.is_admin = localStorage.getItem("is_admin") === "false" ? false : true;
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    },
    roleGroup() {
      let roleGroup = this.$store.state.roleGroup;
      return roleGroup;
    }
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        if (data[i].department) {
          for (let j in this.departmentGroup) {
            if (data[i].department == this.departmentGroup[j].ID) {
              data[i].departmentName = this.departmentGroup[j].Name;
            }
          }
        }
        data[i].roleName = "";
        for (let k in data[i].roles) {
          for (let l in this.roleGroup) {
            if (data[i].roles[k] == this.roleGroup[l].ID) {
              data[i].roleName += this.roleGroup[l].Name + " ";
            }
          }
        }
      }
      return data;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
    },
    add() {
      this.updateBlock = true;
      this.updateType = "add";
      this.updateForm = {};
    },
    deletedata(val) {
      let url = "users/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    close() {
      this.updateBlock = false;
    }
  }
};
</script>
